import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/styles';
import {Card, CardContent, Grid, Typography, Avatar} from '@material-ui/core';
import BarChartIcon from '@material-ui/icons/BarChart';
import {StatusArrow} from 'components';

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%'
    },
    content: {
        alignItems: 'center',
        display: 'flex'
    },
    title: {
        fontWeight: 700
    },
    avatar: {
        backgroundColor: theme.palette.success.main,
        height: 56,
        width: 56
    },
    icon: {
        height: 32,
        width: 32
    },
    statusContainer: {
        marginTop: theme.spacing(2),
        display: 'flex',
        alignItems: 'center'
    },
    status: {
        marginRight: theme.spacing(1)
    },
    up: {
        color: theme.palette.error.main
    },
    down: {
        color: theme.palette.info.main
    },
    middle: {
        color: theme.palette.black
    },
    caption: {
        marginLeft: theme.spacing(1)
    }
}));

const TotalDeals = props => {
    const {className, data, ...rest} = props;
    const classes = useStyles(props);
    const {total, status, rate} = data;

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardContent>
                <Grid
                    container
                    justify="space-between"
                >
                    <Grid item>
                        <Typography
                            className={classes.title}
                            color="textSecondary"
                            gutterBottom
                            variant="body2"
                        >
                            Total Num. of Deals
                        </Typography>
                        <Typography variant="h3">
                            {total.toLocaleString()}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Avatar className={classes.avatar}>
                            <BarChartIcon className={classes.icon}/>
                        </Avatar>
                    </Grid>
                </Grid>
                <div className={classes.statusContainer}>
                    <StatusArrow
                        className={classes.status}
                        size="md"
                        type={status || 'middle'}
                    />
                    <Typography
                        className={classes[status]}
                        variant="body2"
                    >
                        {`${rate}%`}
                    </Typography>
                    <Typography
                        className={classes.caption}
                        variant="caption"
                    >
                        Since last day
                    </Typography>
                </div>
            </CardContent>
        </Card>
    );
};

TotalDeals.propTypes = {
    className: PropTypes.string,
    data: PropTypes.object.isRequired
};

export default TotalDeals;
